export default {"LABEL":"Grey 中性色","DESC":"中性色是一个不变的辅助色, 横向扩展的配色方案.","COMPONENTS":{"__markdown":true}}